<template>
    <div class="row justify-center " style="min-width: 1200px;min-height: 95vh">
        <q-dialog position="right" v-model="schemePointDialog">
            <SubPartnerPointDetail :isTeam="schemeDetail.isHerirachyScheme"
                                   :partner-id="childPartnerId" :scheme-id="schemeId"
                                   :schemeDetail="schemeDetail" :schemeEnrollmentObj="schemeEnrollmentObj"
                                   @closeDialog="schemePointDialog=false"></SubPartnerPointDetail>
        </q-dialog>
        <div class="card q-pa-md">
            <div class="app-fixed-header" style="width: 1200px; left: unset; top: 20px; right: 0px !important;">
                <div class="d-flex justify-content-between w-100" style="align-items: center; height: 60px;">
                    <h4 style="font-size: 26px; font-weight: 300; margin-left: 25px; ">
                        {{moment(date, 'YYYY-MM-DD').format('MMMM | YYYY')}}
                    </h4>

                    <div class="d-flex" style="justify-content: space-between">
                        <q-btn @click="closeDialog" class="float-right" color="primary" dense flat icon="close">
                            <q-tooltip>Close</q-tooltip>
                        </q-btn>
                    </div>
                </div>
            </div>
            <div class="hv-wrapper" style="margin-top: 60px;">

                <!-- Key component -->
                <div class="hv-item" v-if="parentPoints">
                    <div class="hv-item-parent">
                        <div :style="{backgroundColor:getColor(monthlyPoints,parentPoints.eligiblePoint)+ '!important'}"
                             class="hr_box p-3">
                            <span class="d-block hr-title mb-2">{{parentPoints.Partner?parentPoints.Partner.name:''}}</span>
                            <span class="d-block hr-id my-2">#{{parentPoints.Partner?parentPoints.Partner.partnerCode:''}}</span>
                            <div class="d-flex justify-content-between hr-point">
                                <div>
                                    <span class="bankLabel mb-0 " style="color: #fff; font-size: 12px">My Points</span>
                                    <div class="hr_points py-2">
                                        <span class="d-block text-center">{{parentPoints.eligiblePoint?parentPoints.eligiblePoint:0}}</span>
                                    </div>
                                </div>
                                <div v-if="isTeam">
                                    <span class="bankLabel mb-0 text-white" style="font-size: 12px">My Team</span>
                                    <div class="hr_points py-2">
                                        <span class="d-block text-center">{{parentPoints.myTeamEligiblePoint?parentPoints.myTeamEligiblePoint:0}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="hv-item-children" v-if="isTeam">
                        <div class="hv-item-child">
                            <div class="hv-item">
                                <div class="hv-item-children">
                                    <div @click="getChildPoints(child.schemeId,child.Partner.id)" class="hv-item-child"
                                         style="cursor: pointer" v-for="child in childPoints">
                                        <p :style="{backgroundColor:getColor(monthlyPoints,child.eligiblePoint)+ '!important'}">
                                            <span class="d-block hr-title my-2">{{child.Partner.name}}</span>
                                            <span class="d-block hr-id my-2">#{{child.Partner.partnerCode}}</span>
                                            <span class="d-block hr-point my-2">{{child.eligiblePoint?child.eligiblePoint:0}}</span>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment'
  import {
    GET_PARTNER_FROM_ORG,
    GET_SCHEME_DETAIL_WITH_POINTS,
    GET_SCHEME_POINT_HISTORY,
  } from '../../graphql/queries/schemePoints'
  import SubPartnerPointDetail from '../Partner/Scheme/SubPartnerPointDetail'

  export default {
    name: 'SchemePointHierarchy',
    components: { SubPartnerPointDetail },
    props: ['date', 'partnerId', 'isTeam', 'monthlyPoints'],
    data () {
      return {
        moment: moment,
        orgIds: [],
        childPoints: [],
        parentPoints: [],
        startDate: '',
        endDate: '',
        orgId: JSON.parse(localStorage.getItem('user')).orgId,
        schemePointDialog: false,
        schemeId: '',
        childPartnerId: '',
        schemeDetail: '',
        schemeEnrollmentObj: {
          myTeamEarnPoint: 0,
          myTeamEligiblePoint: 0,
          earnPoint: 0,
          eligiblePoint: 0,
          redemPoint: 0,
          redemptioInProgress: 0,
          transferPoints: 0,
          adjustment: 0,
          returnOrderPoint: 0,
        },
      }
    },
    apollo: {
      Organizations: {
        query: GET_PARTNER_FROM_ORG,
        fetchPolicy: 'network-only',
        variables () {
          return {
            orgId: this.orgId,
          }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.orgIds = []
            data.Organizations.forEach((org) => {
              this.orgIds.push(org.id)
            })
          }
        },
      },
      SchemePointHistory: {
        query: GET_SCHEME_POINT_HISTORY,
        fetchPolicy: 'network-only',
        variables () {
          return {
            orgId: this.orgIds,
            startDate: this.startDate,
            endDate: this.endDate,
            schemeId: localStorage.getItem('schemeId'),
          }
        },
        skip: true,
        result ({ data, loading }) {
          if (!loading) {
            this.childPoints = data.SchemePointHistory
          }
        },
      },
      SchemePointHistoryParent: {
        query: GET_SCHEME_POINT_HISTORY,
        fetchPolicy: 'network-only',
        variables () {
          return {
            orgId: [this.orgId],
            startDate: this.startDate,
            endDate: this.endDate,
            schemeId: localStorage.getItem('schemeId'),
          }
        },
        skip: true,
        result ({ data, loading }) {
          if (!loading) {
            this.parentPoints = data.SchemePointHistory ? data.SchemePointHistory[0] : ''
          }
        },
      },
    },
    mounted () {
      this.startDate = moment(this.date, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD')
      this.endDate = moment(this.date, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
      this.$apollo.queries.SchemePointHistory.skip = false
      this.$apollo.queries.SchemePointHistoryParent.skip = false
    }, methods: {
      async getChildPoints (schemeId, partnerId) {
        this.schemeId = schemeId
        this.childPartnerId = partnerId
        let response = await this.$apollo.query({
          query: GET_SCHEME_DETAIL_WITH_POINTS,
          fetchPolicy: 'network-only',
          variables: {
            id: schemeId,
            partnerId: partnerId,
          },
        })
        if (response.data) {
          this.schemeDetail = response.data.Scheme[0]
          this.schemeEnrollmentObj = response.data.Scheme[0].SchemeEnrollments.length
            ? response.data.Scheme[0].SchemeEnrollments[0]
            : this.schemeEnrollmentObj
          this.schemePointDialog = true
        }
      },
      closeDialog () {
        this.$emit('closeDialog')
      },
      getColor (monthlyPoint, point) {
        if (monthlyPoint) {
          if (monthlyPoint <= point)
            return '#3EB957'
          else
            return '#DE5454'
        } else return '#DE5454'
      },
    },
  }
</script>

<style scoped>

    .card {
        text-align: center;
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
